exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontStyle[data-v-faf5ae8a]{font-size:12px}.errorStyle[data-v-faf5ae8a]{font-weight:bolder;color:red}", ""]);

// exports
